import React, { useState } from 'react';
import { ButtonField, InputField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem } from '@wk/components-react16';
import Api from '../../../core/api';
import { API_USER } from '../../../core/constants';
import { logUserActivity, Toast, UserActivity } from '../../../services';

const AddPrivilege = ({ isAddPrivilege, setIsAddPrivilegeOpen }: any) => {
    const [newprivilege, setNewprivilege] = useState('')
    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setNewprivilege('');
            setIsAddPrivilegeOpen(false);
        }
    }

    const addPrivilege = () => {
        if (newprivilege.trim() === '') {
            Toast("Please enter privilege name", "error")
            return;
        }
        let payload = { name: newprivilege.trim() }
        Api.postRequest(API_USER.ADD_PRIVILEGE, payload).then(
            (res: any) => {
                setNewprivilege('');
                setIsAddPrivilegeOpen(false);
                Toast("Privilege added successfully.", "sucsess");
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
        let userActivity: UserActivity = {
            action: 'Save Button Click',
            page: 'Role Management',
            viewName: 'Add Privilege',
            entityName: payload.name
        }
        logUserActivity(userActivity);
    }

    return (
        <>
            <Modal
                isOpen={isAddPrivilege}
                srLabelledBy={'modal-id-001'}
                srDescribedBy={'modal-id-002'}
                width={'432px'}
                onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-001'}
                    isFullscreenButtonVisible
                    onUserRequest={() => handleUserRequest('header')}>
                    Add Privilege{' '}
                </ModalHeader>
                <ModalBody descriptionId="modal-id-002">
                    <div className="wk-row">
                        <div className="wk-col-12">
                            <InputField
                                label="Privilege Name"
                                labelFor="privilege-1"
                                size="small" indicator="required">
                                <input
                                    type="text"
                                    id="privilege-1"
                                    name="privilege"
                                    value={newprivilege}
                                    onChange={e => setNewprivilege(e.target.value)}
                                    placeholder="Enter new privilege"
                                    autoComplete="off"
                                />
                            </InputField>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'} mode={'text'}>
                                <button type="button" id="cancel" onClick={() => handleUserRequest('footer')}>
                                    Cancel
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'}>
                                <button type="button" id="add" disabled={newprivilege.length === 0} onClick={() => addPrivilege()}>
                                    Save
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal >
        </>
    );
};

export default AddPrivilege;
